// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3dY5P","inputWrap":"CustomTip_inputWrap__huHb6"};